import IAction from "../../types/IAction";
import { OBNotificationData } from "../../types/OBTypes";
import actionTypes from "../actionTypes";

export const pickOnBoardingTitle = (title: string): IAction => {
  return {
    type: actionTypes.PICK_ONBOARDING_TITLE,
    payload: title
  };
};

export const pickOnBoardingSubTitle = (subTitle: string): IAction => {
  return {
    type: actionTypes.PICK_ONBOARDING_SUBTITLE,
    payload: subTitle
  };
};

export const pickOnBoardingNotification = (
  notification: OBNotificationData
): IAction => {
  return {
    type: actionTypes.PICK_ONBOARDING_NOTIFICATION,
    payload: notification
  };
};
